import { Component, type ReactNode, Suspense } from "react";

interface LazyBoundaryProps {
  children: ReactNode;
  fallback?: ReactNode;
}

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
}

export const LazyBoundary = ({ children, fallback = null }: LazyBoundaryProps) => (
  <ChunkErrorBoundary>
    <Suspense fallback={fallback}>{children}</Suspense>
  </ChunkErrorBoundary>
);

class ChunkErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  render() {
    if (this.state.hasError) {
      const alreadyReloaded = sessionStorage.getItem("chunk-reload") === "1";

      if (!alreadyReloaded) {
        sessionStorage.setItem("chunk-reload", "1");
        window.location.reload();
        return null;
      }

      return (
        <div className="flex h-screen flex-col items-center justify-center gap-4 text-center">
          <p className="text-zinc-600">Something went wrong. Please refresh the page.</p>
          <button
            type="button"
            onClick={() => {
              sessionStorage.removeItem("chunk-reload");
              window.location.reload();
            }}
            className="rounded-lg bg-primary px-4 py-2 text-sm text-white"
          >
            Refresh
          </button>
        </div>
      );
    }

    sessionStorage.removeItem("chunk-reload");
    return this.props.children;
  }
}
